<template>
<div class="reportBox">
    <Modal
        :value="showModel"
        :title="$t('deviceManage.reportModel.title')"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'900px'}">

        <!-- <div style="margin-bottom:10px">{{ $t("deviceManage.reportModel.tip") }}</div> -->

        <div  class="search-div flexC">
            <div class="search-div-item">
                <SearchSelectRecycle
                  refName="devideAttrRef" 
                  ref="devideAttrRef" 
                  :showPage="true" 
                  :errorShow="true" 
                  :selectUrlQuery="{'serialNumber':editFormData.serialNumber}" 
                  :url="searchDeviceAllAttrUrl" 
                  labelName="keyNameText"
                  isMultiple='2'  
                  valName="id"
                  keyword="keyNameText" 
                  :labelInValue="true" 
                  :placeholderText="$t('selectPlaceholder')" 
                   @setSelected="setSelectValNew($event)"></SearchSelectRecycle>
             </div>
            <div class="search-div-item">
                <Button type="info" @click="searchItem"  icon="ios-search" style="margin-left:20px;width:96px;border-radius: 10px;">{{$t('search')}}</Button>
             </div>
        </div>
      
        <Table  max-height="510" :border="true" :columns="titleName" :data="tableList.tableData" :loading="loading"></Table>

        <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[10,20,30,50,100]" placement="top" class="pages"/>

        
    </Modal>
</div>
</template>
<script>
/**
 * 弹框，设备移动组织
 * 
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import { mapState } from 'vuex'
import SearchSelectRecycle from './selectListRecycleReport.vue';  //20220415
import { render } from 'less';
import { cloneDeep } from 'lodash';
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model3",
        components: {
            SearchSelectRecycle
        },
        data() {
            return {   
                searchDeviceAllAttrUrl: this.config.urlArray.getDeviceAllAttr,
                totalNum:'20',
                loading:false,
                tableList:{//表格组
                    hasSelectData:{},//已选中的行的数据
                    tableData: []//表格数据
                },
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                    loraEUI:'',
                    identifier:'',
                    commandKey:'',
                    commandKeyType:''
                },
                page:{//分页排序
                    total:0,//总条数
                    pageSize:10,//每页条数
                    current:1,//当前页
                    key:'created_at',
                    order:'desc'
                },
                titleName:[],
                formatType:'',
                keyListObj:{},
                attrArray:[]
            }
        },
        computed:{
            ...mapState(['local']),
            ruleCustom(){
                return {//验证
                    deviceGroupId: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ]
                }
            },
            titleName1(){
                return [
                    {
                        title: this.$t('deviceManage.reportModel.type'),
                        key: 'id',
                        with: 120,
                        render: (h, params) => {
                            let that = this
                            return h('div',{
                                     style:{
                                       
                                     }
                                 },params.row.identifier
                            )
                           
		    	        }
                    },
                    // {
                    //     title: this.$t('deviceManage.reportModel.type'),
                    //     key: 'id',
                    //     with: 80,
                    //     render:(h,params)=>{
                    //         let that = this
                    //         let res = params.row.keyName
                    //         let keyNameObj = null

                    //         if(res){
                    //             try {
                    //                 keyNameObj = JSON.parse(res)
                    //             } catch (error) {
                                    
                    //             }
                    //         }
                    //         if(keyNameObj && keyNameObj.LanguageKey){
                    //             res = this.local=='zh-CN'? (keyNameObj['CN'] || ''):(keyNameObj['EN']  || '') 
                    //         }

                    //         return h('div',{
                    //             attrs:{
                    //                title:res,
                    //             },
                    //         },res)
                    //     }
                    // },
                    {
                        title: this.$t('deviceManage.reportModel.value'),
                        key: 'identifierValue',
                        minWidth: 200,
                        render: (h, params) => {
                            let that = this
                            let res = params.row.resVal?params.row.resVal: params.row.identifierValue
                            return h('div',{
                                    attrs:{
                                       title:res,
                                    },
                                 },res
                            )
                           
		    	        }
                    },
                    
                    {
                        title: this.$t('setting.registerTime'),
                        key: 'createDate',
                        width: 200,
                        render:(h, params)=>{
                            let stext = params.row.createDate?moment(params.row.createDate*1).format('YYYY-MM-DD HH:mm:ss'):''
                             return h('div',stext || '')
                        }
                    }
                 ]
            } ,
            titleName2(){
                return [
                    {
                        title: this.$t('deviceManage.reportModel.commandKeyType'),
                        key: 'commandKeyType',
                        with: 40,
                        render:(h,params)=>{
                            let that = this

                            // let formatType = that.editFormData.designImplType

                            let res = params.row.commandKeyType
                            if(that.editFormData.designImplType==2){
                                res = common.dec2hex( params.row.commandKeyType)
                            }

                            return h('div',{},res)
                        }
                    },
                    {
                        title: this.$t('deviceManage.reportModel.commandKey'),
                        key: 'commandKey',
                        with: 40,
                        render:(h,params)=>{
                            let that = this
                            let res = params.row.commandKey
                            if(that.editFormData.designImplType==2){
                                res = common.dec2hex( params.row.commandKey)
                            }

                            return h('div',{},res)
                        }
                    },
                    {
                        title: this.$t('deviceManage.reportModel.value'),
                        key: 'commandValue',
                        minWidth: 220,
                        render: (h, params) => {
                            let that = this
                            let res = params.row.resVal?params.row.resVal: params.row.commandValue
                  
                            return h('div',{
                                attrs:{
                                   title:res,
                                },
                                 },res
                            )
                           
		    	        }
                    },
                    
                    {
                        title: this.$t('setting.registerTime'),
                        key: 'createDate',
                        minWidth: 80,
                        render:(h, params)=>{
                            let stext = params.row.createDate?moment(params.row.createDate*1).format('YYYY-MM-DD HH:mm:ss'):''
                             return h('div',stext || '')
                        }
                    }
                 ]
            } 

        },
        mounted(){
           
        },
        methods: {
            async getAllAttr(){
                let res = await  this.axios.post(this.config.urlArray.getDeviceAllAttr, {'serialNumber':this.editFormData.serialNumber})

                if(res && res.data){
                    this.attrArray = res.data.data || []
                }
            },
            setSelectValNew(e){
                // console.log('e',e)
              if(e){

                 if(this.editFormData.designImplType==3){
                    this.formData.identifier = e.identifier
                 }else{
                    this.formData.commandKey = e.commandKey
                    this.formData.commandKeyType = e.commandKeyType
                 }
                 this.formatType = e.formatType
                 this.keyListObj = cloneDeep(e)

              }else{
                Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                this.keyListObj = {}
                this.formatType = ''
              }
            },
            searchItem(){ //搜索
                this.loading = true
                this.page.current = 1
                this.page.pageSize = 10
                
                this.formData.loraEUI = this.editFormData.serialNumber
                this.getData()
            },
            getData(changeType=0) {//获取数据 ,changeType为0代表首次获取数据，为1代表切换分页或者显示条数
                let params= {
                        page: this.page.current,
                        limit: this.page.pageSize,
                        sortfield: this.page.key,
                        ascDesc: this.page.order,
                        dealerId:this.selectId,
                        loraEUI:this.formData.loraEUI
                    }

                    
                    if(this.formatType){

                        if(this.editFormData.designImplType==3){
                            params.identifier = this.formData.identifier
                        }else{
                            params.commandKey = this.formData.commandKey
                            params.commandKeyType = this.formData.commandKeyType
                        }
                    }
                
               
                
    
                this.axios.post(this.config.urlArray.getDeviceRecordAndMessage, params).then((result) => {
                    // common.ajaxMsg(result.data);
                    let resData = result.data.data.recordMessageList

                    let keyList = []

                    if(Object.keys(this.keyListObj).length){
                        keyList = [this.keyListObj]
                    }




                 
                    // 处理数据
                    if(resData.length){
                        let formatType = null
                        let formatContentObj = null
                        
                        if( Object.keys(this.keyListObj).length){

                            formatType = keyList[0].formatType
    
                            try {
                                formatContentObj = JSON.parse(keyList[0].formatContent)
                            } catch (error) {
                                
                            }
                        }


                


                        resData = resData.map((item)=>{
                            // 得到的item.identifierValue或者item.commandValue 是设备返回的16进制
                            let bytes = this.editFormData.designImplType==3?item.identifierValue:item.commandValue


                           

                            
                            // 如果搜索是空的情况
                            if(!Object.keys(this.keyListObj).length){
                               
                                for(let i=0;i<this.attrArray.length;i++){
                                    if(item.hasOwnProperty('commandKey')){
                                        if(item.commandKey==this.attrArray[i].commandKey && item.commandKeyType==this.attrArray[i].commandKeyType){
                                            item.formatType = this.attrArray[i].formatType;
                                            try {   
                                                item.formatContentObj = JSON.parse(this.attrArray[i].formatContent)
                                            } catch (error) {
                                                item.formatContentObj=null
                                            }
                                            item.keyList = [cloneDeep(this.attrArray[i])]

                                            break
                                        }
                                    }
                                    if(item.hasOwnProperty('identifier')){
                                       

                                        if(item.identifier==this.attrArray[i].identifier){
                                            item.formatType = this.attrArray[i].formatType;


                                            try {
                                                item.formatContentObj = JSON.parse(this.attrArray[i].formatContent)
                                            } catch (error) {
                                                item.formatContentObj=null
                                            }
                                            item.keyList = [cloneDeep(this.attrArray[i])]

                                            break
                                        }
                                    }
                                }
                            }

                            // 如果搜索有选中的情况

                            
                            formatType = Object.keys(this.keyListObj).length?formatType:(item.formatType || 0)
                            keyList = Object.keys(this.keyListObj).length?keyList: item.keyList
                            formatContentObj =Object.keys(this.keyListObj).length?formatContentObj: item.formatContentObj

                            console.log('formatType',formatType)
                            console.log('keyList',keyList)
                            console.log('formatContentObj',formatContentObj)

                            if(formatType){
                                //Hex Bitvalue  -------
                                if(formatType==11){//Hex Bitvalue

                                    


                                     let hexValueBytes = keyList[0].hexValueBytes || 0
                                     let twoV = common.string_hex2two(bytes,hexValueBytes*8)
                                     let res1Arr = []
    
                                     let resStr = ''

                                     

                                     if(formatContentObj){

                                         for(let i=0;i<formatContentObj.length;i++){
         
                                             // 根据Offset和Len 截取二进制字符串
                                             let itemV = twoV.slice( Number(formatContentObj[i].Offset)-1,Number(formatContentObj[i].Offset-1)+Number(formatContentObj[i].Len))
                                             
                                             let keyNameText = this.local=='zh-CN'?( formatContentObj[i]['Name-CN'] || ''):(keyNameObj['Name-EN'] || '')
                                             let LanguageKey =formatContentObj[i]['LanguageKey'] || ''



                                             
         
         
                                             // 把二进制字符串转为十进制，如果Negative 为负数，看开始的第一个bit，如果是1代表负数 0代表正数
                                             let decV = 0
                                             if(formatContentObj[i].Negative=='N'){
                                                 decV = parseInt(itemV,2)
                                             }else{
                                                 decV = common.string_two2tenSymbol(itemV)
         
                                             }

                                            
         
                                             // 转换成十进制后看multiple，十进制除multiple
         
                                             if(common.isNumberStr(formatContentObj[i].Multiple) && formatContentObj[i].Multiple!=0){
                                                 decV = decV / formatContentObj[i].Multiple
                                             }

                                             
                                             if(keyNameText=='时间' || keyNameText=='Time' || LanguageKey=='wg100lr_time' || keyNameText.includes('时间') || keyNameText.includes('Time')){
                                                 if((decV+'').length==10){
                                                     decV = decV*1000
                                                 }
         
                                                 decV = moment(decV).format('YYYY-MM-DD HH:mm:ss')
                                             }

                                            
         
         
         
                                             if(keyList[0].commandKeyType && keyList[0].commandKeyType==6 && keyList[0].commandKey==49){// 0x06-0x31 ,设备通信层记录,日期时间(4 Bytes) + RSSI + SNR + 失败次数 + 状态
                                                
                                                //  RSSI 为负数
                                                if(keyNameText=='RSSI' || keyNameText=='RSSI' || LanguageKey=='wv100lr_rssi'){
                                                  decV = -1*decV
                                                }
         
                                                // SNR  bit7:0正；1负
                                                if(keyNameText=='SNR' || keyNameText=='SNR' || LanguageKey=='wv100lor_snr'){
                                                  let twoSNR = common.string_ten2two(decV,8)
                                                  decV = common.string_two2tenSymbol(twoSNR)
                                                }
         
                                                 // 状态用2进制显示，bit0:超时未关水；bit1:开始计时出错，bit2:停止计时出错；bit3:发送入网出错；bit4:Slot设置失败，bit5:Flash写入失败;bit6:wdt重启；bit7：正常复位
                                                if(keyNameText=='状态' || keyNameText=='State' || LanguageKey=='wv100lr_state'){
                                                  decV = common.string_ten2two(decV,8)
                                                }
         
                                               
         
                                             }
         
                                             let ii = {
                                                 [keyNameText]:decV
                                             }
                                             // if(!(keyNameText=='时间' || keyNameText=='Time' || LanguageKey=='wg100lr_time')){
         
                                             //     res1Arr.push(ii)
                                             // }
         
                                             res1Arr.push(ii)
                                            
                                         }
                                     }

    
                                    //  console.log('666666')
                                    if(keyList[0].commandKeyType && keyList[0].commandKeyType==6 && keyList[0].commandKey==49){//0x06-0x31
                                        if(bytes.slice(-2)=='80'){
                                            res1Arr.push({
                                                "是否重启":"重启入网包"
                                            })
                                        }else{
                                            res1Arr.push({
                                                "是否重启":"非重启入网包"
                                            })
                                        }
                                    }
                                
                                    resStr = JSON.stringify(res1Arr)
                                    resStr = resStr.replace(/[{}]/g, '').replace(/[[\]]/g, '')
    
                                    item.resVal = resStr

    
                                }
                                
    
                                // 各种数值型 -----
                            //     formatTypeList1:[
                            //        {id:16,val:'int32(整数型)'},
                            //        {id:15,val:'float(单精度浮点型)'},
                            //        {id: 1,val:'double(双精度浮点型)'},
                            //        {id: 2,val:'enum(枚举型)'},
                            //        {id: 3,val:'bool(布尔型)'},
                            //        {id: 4,val:'text(字符串)'},
                            //        // {id: 5,val:'Bitvalue'},
                            //        {id: 6,val:'date(时间型)'},
                            //        {id:13,val:'struct(结构体)'},
                            //        {id:17,val:'array(数组)'},
                            //    ],
                            //    formatTypeList2:[
                            //        {id: 7,val:'Hex Numerical'},
                            //        {id: 14,val:'Hex SNumerical'},//数值型，16进制，有符号
                            //        {id: 8,val:'Hex Enumeration'},
                            //        {id: 9,val:'Hex Boolean'},
                            //        {id: 10,val:'Hex String'},
                            //        {id: 11,val:'Hex Bitvalue'},
                            //        {id: 12,val:'Hex Datetime'},
                            //    ],
                                // 
                                let formatTypeNumberArr1 = [7]   //数值型，16进制，无符号
                                let formatTypeNumberArr2 = [14]  //数值型，16进制，有符号
                                let formatTypeNumberArr3 = [1,15,16] //数值型 double(双精度浮点型) float(单精度浮点型) int32(整数型)

                                if(formatTypeNumberArr1.includes(formatType)){
                                    // 16进制转10进制
                                     let resStr = parseInt(bytes,16)

                                     
                                     let unitText = ''
                                  
                                       if(keyList.length){
                                           
                                            let hexValueBytes = keyList[0].hexValueBytes || 0
                                            let twoV = common.string_hex2two(bytes,hexValueBytes*8)


                                            //  // 如果
                                            //  if(formatContentObj && resStr>formatContentObj[0].Max && twoV.slice(0,1)==1){
                                                 
                                            //      let twoVone =parseInt(twoV.replace(/^1/, '0'),2) 
        
                                            //      let flagV = resStr-twoVone
        
                                            //     if(flagV==Math.pow(2,len)){
                                            //      resStr = common.string_two2tenSymbol(twoV)
                                            //     }
                                            //  }
                                             //把设备上报放大的倍数处理掉    
                                             if(formatContentObj && common.isNumberStr(formatContentObj[0].Multiple) && formatContentObj[0].Multiple!=0){
                                                 resStr = resStr / formatContentObj[0].Multiple
                                             }


                                             // 如果有单位，加单位
                                             if(formatContentObj){

                                                 unitText = this.local=='zh-CN'? (formatContentObj[0]['Unit-CN'] || ''):(formatContentObj[0]['Unit-EN']  || '') 
                                                 unitText = (unitText=='无' || unitText.toLocaleLowerCase() =='none') ?'':unitText
                                                 unitText = (unitText=='否' || unitText.toLocaleLowerCase() =='no') ?'':unitText

                                             }

                                       }
                                    item.resVal = resStr +' '+  unitText
                                }

                                if(formatTypeNumberArr2.includes(formatType)){
                                    // 16进制转10进制
                                     let resStr = parseInt(bytes,16)
                                     let unitText = ''
                                  
                                    if(keyList.length){
                                            let hexValueBytes = keyList[0].hexValueBytes || 0
                                            let twoV = common.string_hex2two(bytes,hexValueBytes*8)
                                            resStr = common.string_two2tenSymbol(twoV)
                                            //把设备上报放大的倍数处理掉    
                                            if(formatContentObj && common.isNumberStr(formatContentObj[0].Multiple) && formatContentObj[0].Multiple!=0){
                                                 resStr = resStr / formatContentObj[0].Multiple
                                             }

                                             // 如果有单位，加单位
                                             if(formatContentObj){

                                                 unitText = this.local=='zh-CN'? (formatContentObj[0]['Unit-CN'] || ''):(formatContentObj[0]['Unit-EN']  || '') 
                                                 unitText = (unitText=='无' || unitText.toLocaleLowerCase() =='none') ?'':unitText
                                                 unitText = (unitText=='否' || unitText.toLocaleLowerCase() =='no') ?'':unitText
                                             }
                                     }
                                   
    
                                    item.resVal = resStr +' '+  unitText
                                }

                                if(formatTypeNumberArr3.includes(formatType)){
                                    
                                     let resStr = bytes
                                     let unitText = ''
                                  
                                       if(keyList.length){
                                           
                                            //把设备上报放大的倍数处理掉    
                                            if(formatContentObj && common.isNumberStr(formatContentObj[0].Multiple) && formatContentObj[0].Multiple!=0){
                                                resStr = resStr / formatContentObj[0].Multiple
                                            }


                                            // 如果有单位，加单位
                                            if(formatContentObj){
                                                unitText = this.local=='zh-CN'? (formatContentObj[0]['Unit-CN'] || ''):(formatContentObj[0]['Unit-EN']  || '') 
                                                unitText = (unitText=='无' || unitText.toLocaleLowerCase() =='none') ?'':unitText
                                                unitText = (unitText=='否' || unitText.toLocaleLowerCase() =='no') ?'':unitText
                                            }
                                       }
                                   
    
                                    item.resVal = resStr +' '+  unitText

                                }
    
                                // text类型，字符串长度 ----
                                if(formatType==4){
                                    item.resVal = bytes
                                }
                                if(formatType==10){
                                    let resStr = parseInt(bytes,16)
                                    item.resVal = resStr
                                }
    
                                // 版本号,5-1,-2,5-4   classB wv、wc 作为心跳包  ------ ，ws 电池电压作为心跳包，在数值类型的里面做了解析
                                // 或者identifier 
                                if(keyList.length){

                                    let keyName = null
                                    try {
                                        keyName = JSON.parse(keyList[0].keyName)
                                    } catch (error) {
                                        
                                    }

                                    if((keyList[0] && keyList[0].commandKeyType==5 && (keyList[0].commandKey==1 || keyList[0].commandKey==2 || keyList[0].commandKey==4) )){
                                        if(keyName !==null && typeof keyName['CN']=='string' && ( keyName['CN'].includes('软件版') ||  keyName['CN'].includes('硬件版') ||  keyName['CN'].includes('固件版') || keyName['EN'].includes('version'))){

                                            if(bytes.length==4){
                                                let startS = parseInt(bytes.slice(0,2),16)
                                                let endS = parseInt(bytes.slice(2,4),16)
                                                item.resVal = startS+'.'+endS
                                            }else{
                                                item.resVal = bytes
                                            }
                                        }
                                    
                                     }

                                     if(keyList[0] && typeof keyList[0].identifier =='string' && keyList[0].identifier.includes('_version')){
                                        if(keyName !==null && typeof keyName['CN']=='string' && ( keyName['CN'].includes('软件版') ||  keyName['CN'].includes('硬件版') ||  keyName['CN'].includes('固件版') || keyName['EN'].includes('version'))){
                                           if(bytes.length==4 && !bytes.includes(".")){
                                                let startS = bytes.slice(0,2)
                                                let endS = bytes.slice(2,4)
                                                item.resVal = startS+'.'+endS
                                            }else{
                                                item.resVal = bytes
                                            }
                                      
                                        }
                                     }

                                  
                                     
                                  
                                }
                                
                                
    
                                // 时间类型  ------
                                if(formatType==6){
                                    let decV = bytes
    
                                    if(keyList.length && formatContentObj){

                                        let timeObj = {'1':1/1000,'2':1,'3':60,'4':3600,'0x01':1/1000,'0x02':1,'0x03':60,'0x04':3600}  //ms s m h
                                        let timeFormateListOne = {'YYYY-MM-DD':'yyyy-MM-dd','YYYY-MM-DD HH-MM-SS':'yyyy-MM-dd HH:mm:ss'}  //ms s m h
                                        let timeFormateListTwo = {'HH-MM-SS':'HH:mm:ss','HH-MM':'HH:mm','MM-SS':'mm:ss','MM-SS-MS':'mm:ss.SSS','SS-MS':'ss.SSS'}  //ms s m h
    
                                        
                                        let formatContent =  {}

                                        try {
                                            formatContent = formatContentObj[0] 
                                        } catch (error) {
                                            
                                        }


                                        // 把数字转为秒
                                        let secondsV = decV * timeObj[formatContent.time]

                                        // 展示时间
                                        if(timeFormateListOne[formatContent.formate]){
                                            if((decV+'').length==10){
                                                decV = decV*1000
                                            }

                                            if((decV+'').length==13){
                                                decV = moment(decV).format(formatContent.formate || 'YYYY-MM-DD HH:mm:ss')   
                                            }
                                        }

                                        if(timeFormateListTwo[formatContent.formate]){
                                            decV = common.ChangeSeconds(secondsV,timeFormateListTwo[formatContent.formate])
                                        }
                                

        
                                    }
                                    item.resVal = decV
                                }

                                if(formatType==12){
                                    let decV = parseInt(bytes,16);
    
                                    if(keyList.length && formatContentObj){

                                        let timeObj = {'1':1/1000,'2':1,'3':60,'4':3600,'0x01':1/1000,'0x02':1,'0x03':60,'0x04':3600}  //ms s m h
                                        let timeFormateListOne = {'YYYY-MM-DD':'yyyy-MM-dd','YYYY-MM-DD HH-MM-SS':'yyyy-MM-dd HH:mm:ss'}  //ms s m h
                                        let timeFormateListTwo = {'HH-MM-SS':'HH:mm:ss','HH-MM':'HH:mm','MM-SS':'mm:ss','MM-SS-MS':'mm:ss.SSS','SS-MS':'ss.SSS'}  //ms s m h
    
                                        
                                        let formatContent =  {}

                                        try {
                                            formatContent = formatContentObj[0] 
                                        } catch (error) {
                                            
                                        }


                                        // 把数字转为秒
                                        let secondsV = decV * timeObj[formatContent.time]

                                        // 展示时间
                                        if(timeFormateListOne[formatContent.formate]){
                                            if((decV+'').length==10){
                                                decV = decV*1000
                                            }
                                            decV = moment(decV).format(formatContent.formate || 'YYYY-MM-DD HH:mm:ss')
                                        }

                                        if(timeFormateListTwo[formatContent.formate]){
                                            decV = common.ChangeSeconds(secondsV,timeFormateListTwo[formatContent.formate])
                                        }
                                

        
                                    }
                                    item.resVal = decV
                                }

    
                                // 枚举型 ----
                                if(formatType==2 || formatType==8){
                                   
                                        let keyNameText = ''
                                        let hexValue = formatType==8?'0x'+bytes:bytes
                                        let formatContentArr = formatContentObj || []

    
                                        formatContentArr.map(item=>{
                                            let Code = formatType==8 && ( item.Code.startsWith('0X') || item.Code.startsWith('0x'))?'0x'+item.Code.slice(2) :item.Code
    
                                            if(Code==hexValue){
                                                keyNameText = this.local=='zh-CN'? item['Name-CN']:item['Name-EN']
                                            }
                                        })
    
                                        item.resVal = keyNameText
                                    
    
                                }

                                 // 布尔型
                                 if(formatType==3 || formatType==9){
                                    // [{ "Name-CN": "站点1", "Name-EN": "site1", "Code": "false", "LanguageKey": "es100lc_site1", "wordId": "126168", "pageId_wordCode": "_es100lc_site1" }, { "Name-CN": "不启用", "Name-EN": "Disabled", "Code": "true", "LanguageKey": "es100lc_disabled", "wordId": "124824", "pageId_wordCode": "_es100lc_disabled" }]
                                    // [{"Name-CN":"动作","Name-EN":"Action","Code":"0x00","LanguageKey":"eb640lc_label_action","wordId":"137321","pageId_wordCode":"2002_eb640lc_label_action"},{"Name-CN":"高级本地定时数量限制，上限是8个","Name-EN":"The maximum number of local professional timing items is 8","Code":"0x01","LanguageKey":"eb640lc_local_professional_timing_limit","wordId":"137377","pageId_wordCode":"2002_eb640lc_local_professional_timing_limit"}]

                                    let keyNameText = ''
                                    let hexValue = formatType==9?'0x'+bytes:bytes+''
                                    let formatContentArr = formatContentObj || []


                                    formatContentArr.map(item=>{
                                        let Code = formatType==9 && ( item.Code.startsWith('0X') || item.Code.startsWith('0x'))?'0x'+item.Code.slice(2) :item.Code

                                        if(Code==hexValue){
                                            keyNameText = this.local=='zh-CN'? item['Name-CN']:item['Name-EN']
                                        }
                                    })

                                    item.resVal = keyNameText
                                  
                                
                                }
    
                                // 数组
                                if(formatType==17){
    
                                }
    
                                // 结构体
                                if(formatType==13){
    
                                }
                            }else{
                                item.resVal = bytes
                            }
                          

                  
                            return item
                        })
                    }





                    //处理数组
                    this.tableList.tableData  = resData
                    this.page.total = result.data.data.meta.count
                    this.loading = false
                }).catch((err) => {
                    // common.msg('error','获取失败',()=>{})
                });
            },
            matchArrayAndObject(arrayA, objectB) {//根据对象 B 的键名和数组 A 的 keyId 匹配，返回对应的值或枚举项
                const result = {};
            
                // 遍历对象 B 的键值对
                for (const key in objectB) {
        if (objectB.hasOwnProperty(key)) {
            const valueB = objectB[key];

            // 在数组 A 中查找 keyId 与对象 B 的键名相同的项
            const matchedItem = findItemByKeyId(arrayA, key);

            if (matchedItem) {
                // 如果匹配项有 enumItems 或 arrayItems，则查找对应的值
                if (matchedItem.enumItems && Array.isArray(matchedItem.enumItems)) {
                    const matchedEnumItem = findEnumItem(matchedItem.enumItems, valueB);
                    result[key] = matchedEnumItem || valueB; // 返回匹配的枚举项或原始值
                } else if (matchedItem.arrayItems && Array.isArray(matchedItem.arrayItems)) {
                    const matchedArrayItem = findArrayItem(matchedItem.arrayItems, valueB);
                    result[key] = matchedArrayItem || valueB; // 返回匹配的数组项或原始值
                } else {
                    // 如果没有 enumItems 或 arrayItems，直接返回值
                    result[key] = valueB;
                }
            } else if (typeof valueB === "object" && valueB !== null) {
                // 如果值是对象或数组，递归处理
                result[key] = matchArrayAndObject(arrayA, valueB);
            } else {
                // 未找到匹配的 keyId
                result[key] = valueB;
            }
        }
                }
            
                return result;
            },
            findItemByKeyId(arrayA, keyId) {//在数组 A 中查找 keyId 匹配的项
                for (const item of arrayA) {
                    if (item.keyId === keyId) {
                        return item;
                    }
                    // 如果 item 有 arrayItems，递归查找
                    if (item.arrayItems && Array.isArray(item.arrayItems)) {
                        const nestedMatch = findItemByKeyId(item.arrayItems, keyId);
                        if (nestedMatch) {
                            return nestedMatch;
                        }
                    }
                }
                return null;
            },
            findEnumItem(enumItems, value) {//在 enumItems 中查找匹配的 Code
                for (const enumItem of enumItems) {
                    if (enumItem.Code === value.toString()) {
                        return enumItem;
                    }
                }
                return null;
            },
            findArrayItem(arrayItems, value) {//在 arrayItems 中查找匹配的项
                for (const item of arrayItems) {
                    if (item.keyId && item.keyId === value) {
                        return item;
                    }
                    // 如果 item 有 enumItems，查找匹配的 Code
                    if (item.enumItems && Array.isArray(item.enumItems)) {
                        const matchedEnumItem = findEnumItem(item.enumItems, value);
                        if (matchedEnumItem) {
                            return matchedEnumItem;
                        }
                    }
                    // 如果 item 有 arrayItems，递归查找
                    if (item.arrayItems && Array.isArray(item.arrayItems)) {
                        const nestedMatch = findArrayItem(item.arrayItems, value);
                        if (nestedMatch) {
                            return nestedMatch;
                        }
                    }
                }
                return null;
            },
            async openOrClose(value) {
                if(value === true) {
                    this.titleName = this.editFormData.designImplType==3?this.titleName1:this.titleName2

                    this.$nextTick(()=>{//select赋值，图片赋值
                        this.$refs.devideAttrRef.getData()
                    });   
                  await this.getAllAttr()
                  await this.searchItem()
                } else { 
                    this.resetForm();//重置表单
                    this.$refs.devideAttrRef.clearVal();
                }
            },
            changePage(nowpage) {//切换分页
                this.page.current = nowpage;
                this.getData(1);
            },
            changeSize(nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                this.getData(1)
            },
            clearTable() { //删除后清空编辑数据 与按钮状态
                this.page.current = 1
                this.page.pageSize = 10
                this.page.total = 0
                this.tableList.tableData = []
            },
            cancel() {//对话框关闭
                this.resetForm()
                this.clearTable()
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.disabled = false;
                this.loading = false
                this.formatType = ''
                this.titleName = []
                this.keyListObj = {}
                Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                this.$emit('update:showModel',false);
            }
        }
    }
</script>
<style lang="less" scoped>
/deep/  .ivu-table-body{
    max-height: 480px !important;
}
</style>

